import pino from 'pino'
import { sendToSentry } from './sentry'

export const logger = pino({
	level: import.meta.env.PROD ? 'silent' : 'info',
	browser: {
		asObject: true,
		serialize: true,
		formatters: {
			level: label => ({ level: label })
		},
		disabled: import.meta.env.PROD,
		...(import.meta.env.PROD ? { transmit: { level: 'error', send: sendToSentry } } : {})
	}
})
